/* Mr Swainstons branded pages: reveal-on-scroll, open-now status, timeline rail */
(function () {
  if (window.__spPages) return;
  window.__spPages = true;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.sp [data-sp-rise]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Opening hours: data-sp-hours='{"mon":["10:00","18:00"],...}' on a container.
     Marks today's row and writes "Open now · closes 6pm" style text into [data-sp-status]. */
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  function londonNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      var day = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday)];
      return { day: day, mins: (+o.hour % 24) * 60 + (+o.minute) };
    } catch (e) { var d = new Date(); return { day: DAYS[d.getDay()], mins: d.getHours() * 60 + d.getMinutes() }; }
  }
  function toMins(t) { var m = /^(\d{1,2}):?(\d{2})?$/.exec(String(t || '').trim()); return m ? (+m[1]) * 60 + (+(m[2] || 0)) : null; }
  function nice(t) { var m = toMins(t); if (m === null) return t; var h = Math.floor(m / 60), mm = m % 60, s = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + s; }
  function hours() {
    document.querySelectorAll('[data-sp-hours]').forEach(function (box) {
      var data; try { data = JSON.parse(box.getAttribute('data-sp-hours')); } catch (e) { return; }
      var now = londonNow(), today = data[now.day] || [], open = toMins(today[0]), close = toMins(today[1]);
      var row = box.querySelector('[data-day="' + now.day + '"]'); if (row) row.classList.add('is-today');
      var txt, state;
      if (open !== null && close !== null && now.mins >= open && now.mins < close) { state = 'open'; txt = 'Open now · closes ' + nice(today[1]); }
      else if (open !== null && now.mins < open) { state = 'soon'; txt = 'Closed · opens today at ' + nice(today[0]); }
      else {
        state = 'closed'; txt = 'Closed now';
        for (var i = 1; i <= 7; i++) { var dn = DAYS[(DAYS.indexOf(now.day) + i) % 7], d = data[dn]; if (d && toMins(d[0]) !== null) { txt = 'Closed · opens ' + (i === 1 ? 'tomorrow' : dn.charAt(0).toUpperCase() + dn.slice(1)) + ' at ' + nice(d[0]); break; } }
      }
      document.querySelectorAll('[data-sp-status]').forEach(function (el) { el.textContent = txt; el.setAttribute('data-state', state); el.hidden = false; });
    });
  }

  /* Timeline rail fill follows the scroll */
  function rails() {
    var list = document.querySelectorAll('[data-sp-rail]');
    if (!list.length) return;
    function update() {
      list.forEach(function (tl) {
        var r = tl.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.6 - r.top) / Math.max(1, r.height)));
        tl.style.setProperty('--sp-fill', (p * 100).toFixed(1) + '%');
        tl.querySelectorAll('[data-sp-dot]').forEach(function (d) {
          var dr = d.getBoundingClientRect(); d.classList.toggle('is-lit', dr.top < vh * 0.6);
        });
      });
    }
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() { reveal(); hours(); rails(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); hours(); rails(); });
})();
